/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Loader, Grid } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Line, Bar } from 'react-chartjs-2';

import ChartCard from '../Chart/ChartCard';
import ChartLegend from '../Chart/ChartLegend';

import SocketStatusContainer from '../../containers/SocketStatusContainer';

import styles from './Trends.module.scss';

import { lineOptions, barOptions, lineLegends, barLegends } from '../../utils/demo/chartsData';

const Trends = React.memo(({ isInitializing }) => {
  const [t] = useTranslation();

  return (
    <>
      {isInitializing ? (
        <Loader active size="massive" />
      ) : (
        <div className={styles.main}>
          <h2 className="page-title">{t('common.trends')}</h2>
          <Grid className="mb1">
            <Grid.Row>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <div className={`bg-white ${styles.chart_wrapper}`}>
                  <ChartCard title="Lines">
                    <>
                      <Line {...lineOptions} />
                      <ChartLegend legends={lineLegends} />
                    </>
                  </ChartCard>
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <div className={`bg-white ${styles.chart_wrapper}`}>
                  <ChartCard title="Bars">
                    <>
                      <Bar {...barOptions} />
                      <ChartLegend legends={barLegends} />
                    </>
                  </ChartCard>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      )}
      <SocketStatusContainer />
    </>
  );
});

Trends.propTypes = {
  isInitializing: PropTypes.bool.isRequired,
};

export default Trends;
